module.exports = __webpack_public_path__ + "static/TMN_background_2-bd725eca4424d1726c3a54a197560615.jpg";